export default "__VITE_ASSET__Bz2C7Nq$__"